$(document).ready(function(){
const hamburger = document.querySelector(".hamburger");
const menu = document.querySelector(".main-menu");

hamburger.addEventListener("click", () => {
  hamburger.classList.toggle("active");
  menu.classList.toggle("active");
  if (document.querySelector('.main-menu').classList.contains('active')) {
    document.querySelector('.shop-controls-block').classList.add('shop-active');
} else {
    document.querySelector('.shop-controls-block').classList.remove('shop-active');
}
});  
  
 function closeMobileMenu() {
    if (window.innerWidth < 821) {
      document.querySelectorAll('.main-menu a').forEach(function(link) {
        link.addEventListener('click', function () {
          const menu = document.querySelector('.main-menu');
          menu.classList.remove('active');  // REMOVE active
        });
      });
    }
  }

  // Run when page loads
  closeMobileMenu();

  // Re-run if screen size changes (mobile ↔ desktop)
  window.addEventListener('resize', closeMobileMenu);


$(".backbg").each(function () {
  var backbgPath = $(this).attr("src");
  $(this) 
    .parent(".backbgbox")
    .css("background-image", "url(" + backbgPath + ")");
});
new WOW({
  boxClass: 'wow',
  animateClass: 'animate__animated',
  offset: 20,
  mobile: true,
  live: true
}).init();
$('.hero-slider').owlCarousel({
    items: 1,
    loop: true,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayTimeout: 3000,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    smartSpeed: 800   // smooth fade speed
});
$('.products-block-slider').owlCarousel({
    items: 1,
    loop: true,
    nav: true,
    dots: false,
     animateOut: 'fadeOut',   // fade out current slide
    animateIn: 'fadeIn'      // fade in next slide (optional)
});

$('.product-gallery-owl-slider').owlCarousel({
    loop: true,
    margin: 0,
    nav: false,
    dots: true,
    // autoplay: true,
    // autoplayTimeout: 3000,
    responsive: {
        0: {
            items: 1
        },
        768: {
            items: 1
        },
        992: {
            items: 1
        }
    }
});

if(window.innerWidth < 768){
        $('.premium-herbal-lists-slider').owlCarousel({
            loop:false,
            margin:15,
            nav:false, 
            dots:false,
            autoWidth: false,
            mouseDrag: true,
            touchDrag: true,
            pullDrag: true,
            responsive:{
                0:{
                    items:2,
                    stagePadding: 20,
                    margin: 10,
                }
            }
        });
    }
$('.see-in-action-video-slider').owlCarousel({
        loop:true,
        margin:20,
        nav:false,
        dots:false,
        autoWidth: false,
        mouseDrag: true, 
        touchDrag: true,
        pullDrag: true,
        responsive:{
            0:{
                items:1,
                stagePadding: 35,
                margin: 10,
                dots:true,
            },
            768:{
                items:2,
            },
            992:{
                items:4
            }
        }
    });
 
  $('.faq-title').on('click', function(){

        var parent = $(this).parent();

        if(parent.hasClass('active')){
            parent.removeClass('active');
            parent.find('.faq-content').slideUp();
        } else {
            $('.faq-item').removeClass('active');
            $('.faq-content').slideUp();

            parent.addClass('active');
            parent.find('.faq-content').slideDown();
        }

    });
    $('.real-reviews-slider').owlCarousel({
        loop: false,
        margin:20,
        nav:false, 
        dots:false,
        autoWidth: false,
        mouseDrag: true,
        touchDrag: true,
        pullDrag: true,
        responsive:{
            0:{
                items:1,
                stagePadding: 20,
                margin:10,
            },
            768:{
                items:2,
                stagePadding: 20
            },
            992:{
                items:4
            }
        }
    });
    $('.choose-flavour-slider').owlCarousel({
        loop:true,
        margin:15,
        nav:false,
        dots:false,
        responsive:{
            0:{
                items:2.2,
                margin:10,
            },
            768:{
                items:2.5
            },
            992:{
                items:4
            }
        }
    });
$('.product-features-slider').owlCarousel({
    items: 2, 
    margin:100,
    loop: true,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    slideTransition: 'linear',
    smartSpeed: 600,
    responsive: {
        0:   { margin:20,},
        600: { margin:50, },
    }
});
$('.related-product-list-slider').owlCarousel({
    items: 4, 
    margin:40,
    loop: false,
    nav: false,
    dots: true,
    responsive: {
        0:   { margin:20, items: 1},
        600: { margin:25, items: 2},
        1000: { margin:30, items: 4},
    }
});
$('.customer-videos-testimonial').owlCarousel({
    items: 4, 
    margin:25,
    loop: false,
    nav: false, 
    dots: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    stagePadding: 0,

    smartSpeed: 400,
    fluidSpeed: 400,
    dragEndSpeed: 300,
    responsive: {
        0:   { items: 1, margin:10},
        600: { items: 2,margin:15},
        900: { items: 3,margin:20},
        1024: { items: 4,margin:25},
    }
});

var main = $('.main-slider');
var thumbs = $('.thumb-slider');

main.owlCarousel({
    items: 1,
    loop: true,
    dots: false,
    nav: true,
    smartSpeed: 500
}).on('changed.owl.carousel', function (event) {
    let current = event.item.index - event.relatedTarget._clones.length / 2;
    let total = event.item.count;

    current = ((current % total) + total) % total;

    thumbs.find(".thumb").removeClass("active");
    thumbs.find('.thumb[data-index="' + current + '"]').addClass("active");

    thumbs.trigger("to.owl.carousel", [current, 300, true]);
});

// THUMBS
thumbs.owlCarousel({
    items: 4,
    margin: 20,
    dots: true,
    nav: false,
    responsive: {
        0:   {margin:10,},
        600: {margin:15 },
        900: {margin:20 },
        1024: { margin:20 },
    }
});

// CLICK ON THUMB — FIXED
thumbs.on("click", ".thumb", function () {
    let i = $(this).data("index");
    main.trigger("to.owl.carousel", [i, 300, true]);

    thumbs.find(".thumb").removeClass("active");
    $(this).addClass("active");
});

// First image active
thumbs.find('.thumb[data-index="0"]').addClass("active");


// $('.product-features-slider').on('initialized.owl.carousel changed.owl.carousel', function(e) {

//     // Reset all images
//     $('.product-feature-item .front-pic').css('opacity', 1);
//     $('.product-feature-item .back-pic').css('opacity', 0);

//     // Get first visible slide index
//     let firstIndex = e.item.index;
//     let firstItem = $(this).find('.owl-item').eq(firstIndex);

//     // Fade transition
//     firstItem.find('.front-pic').css('opacity', 0);
//     firstItem.find('.back-pic').css('opacity', 1);

// }); 


gsap.registerPlugin(ScrollTrigger);

document.querySelectorAll(".image-box").forEach((box) => {

  let bgImg = box.querySelector(".product-ingredient-bg img");
  let picImg = box.querySelector(".product-ingredient-pic img");

  if (!bgImg) return;

  let tl = gsap.timeline({ paused: true });

  tl.fromTo(bgImg, { opacity: 0 }, {
    opacity: 1,
    duration: 1.8,
    ease: "power2.out"
  });

  tl.fromTo(picImg,
    { opacity: 0, y: -300, scale: 0.9 },
    { opacity: 1, y: 0, scale: 1.01, duration: 0.05, ease: "power2.out" },
    "-=0.5"
  );

  tl.to(picImg, { scale: 1, duration: 0.2, ease: "power1.out" });

  ScrollTrigger.create({
    trigger: box,
    start: "top 85%",
    onEnter: () => tl.play(),
    onEnterBack: () => tl.restart()
  });

});
  

document.querySelectorAll(".rasraj-product-bloc").forEach((box) => {

    const drops = box.querySelectorAll(".drop-item");
    const bowlBefore = box.querySelector(".bowl-before");
    const bowlAfter = box.querySelector(".bowl-after");

    let tl = gsap.timeline({
        scrollTrigger: {
            trigger: box,
            start: "top 70%",   
            toggleActions: "play none none none"
        }
    });

    drops.forEach((drop, index) => {  

        // STEP 1: fade in + start dropping
        tl.fromTo(drop,  
            { y: -70, opacity: 0 },
            {  
                y: 275,               // ⭐ passes behind bowl bottom
                opacity: 1,  
                duration: 1.1,     
                ease: "power2.out"
            }
        );   

        // STEP 2: fade out once completely dropped
        tl.to(drop, {
            opacity: 0,
            duration: 0.4,
            ease: "power1.out"
        });
    });

    // STEP 3: hide bowl-before
    tl.to(bowlBefore, {
        opacity: 0,
        duration: 0.6
    });

    // STEP 4: show bowl-after
    tl.to(bowlAfter, {
        opacity: 1,
        duration: 0.8,
        ease: "power2.out"
    });
});


});
